<ul class="check-list">
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Acceso gratuito a la <span class="color-primary underlined">Banca por Internet para Empresas
                -</span> nivel
            Negocio.<br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Costo cero en mantenimiento: beneficio que se mantiene siempre que se realice al menos una
            transacci&oacute;n
            mensual a trav&eacute;s de la Banca por Internet para Empresas. De lo contrario, a partir del 3er
            mes, se
            cobrar&aacute; mensualmente S/50.00 y/o $15.00, seg&uacute;n la moneda elegida.<br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Dep&oacute;sitos ilimitados (en cuenta propia), en Interbank Agentes y cajeros Global Net.<br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            10 dep&oacute;sitos libres (en cuenta propia), en tienda. <br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Operaciones ilimitadas en interbank Agentes. <br />
        </span>
    </li>

    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            6 operaciones libres en cajeros Global Net. <br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Tarjeta de d&eacute;bito para tu negocio. <br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Estado de cuenta digital. <br />
        </span>
    </li>
    <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
            Tasa de Rendimiento Efectivo Anual (TREA) 0.00%. <br />
        </span>
    </li>
</ul>